import React from "react";
import { Link } from "react-router-dom";
import styles from "./MarketingFooter.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faLinkedinIn, faInstagram } from "@fortawesome/free-brands-svg-icons";

export default function MarketingFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className={`border-top py-4 mt-auto ${styles.footer}`} role="contentinfo">
      <div className="container">
        <div className={`d-flex flex-wrap align-items-center justify-content-between gap-3 ${styles.row}`}>

          {/* Brand */}
          <div className="d-flex align-items-center gap-2">
            <img
              src="/pp-logo.png"
              alt="Pocket Penny"
              className={styles.logoImg}
              height={20}
              width={20}
            />
            <strong className="me-1">Pocket&nbsp;Penny</strong>
            <span className={styles.badge} aria-label="Public Beta">Public&nbsp;Beta</span>
          </div>

          {/* Nav links */}
          <nav aria-label="Footer links">
            <ul className={`nav ${styles.nav}`}>
              <li className="nav-item">
                <Link className="nav-link p-0" to="/privacy">Privacy</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link p-0" to="/terms">Terms</Link>
              </li>
              {/* Disabled for now */}
              {/* <li className={`nav-item ${styles.credit}`}>
                <a
                  className={styles.creditLink}
                  href="https://narathota.com/?ref=pocketpenny.online"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>A project by</span>
                  <img
                    src="/Nara-Logo-Dark.png"
                    alt="Nara"
                    className={`${styles.creditLogo} ${styles.darkLogo}`}
                  />
                  <img
                    src="/Nara-Logo-White.png"
                    alt="Nara"
                    className={`${styles.creditLogo} ${styles.lightLogo}`}
                  />
                </a>
              </li> */}


            </ul>
          </nav>

          {/* Social icons */}
          <div className={`d-flex align-items-center gap-3 ${styles.socials}`}>
            <a href="#" aria-label="Facebook" className={styles.socialLink}>
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a href="#" aria-label="LinkedIn" className={styles.socialLink}>
              <FontAwesomeIcon icon={faLinkedinIn} />
            </a>
            <a href="#" aria-label="Instagram" className={styles.socialLink}>
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>

          {/* Legal */}
          <div className="text-secondary small">
            © {year} All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
